import React from "react";
import moment from "moment";
import Highlighter from "react-highlight-words";
import I18n from "../../i18n/I18n";
import styles from "./InvoiceList.scss";
import Icon from "../common/Icon";
import Helper from "../../helper/Helper";
import Button from "../common/button/Button";
import InvoiceListMobile from "./InvoiceListMobile";
import Tooltip from "react-tooltip";

const StatementList = props => {
  const { data, searchString } = props;

  const statementList = data
    ? data.map((statement, index) => {
        return (
          <tr className={styles.row} key={index}>
            <td>
              <Highlighter
                highlightClassName={styles.highlight}
                searchWords={[searchString]}
                autoEscape={true}
                textToHighlight={statement.invoice_no}
              />
            </td>
            <td>{moment(statement.invoice_date).format("YYYY-MM-DD")}</td>
            <td>{statement.no_of_items}</td>
            <td>{I18n.formatCurrency({ currency: statement.invoice_ccy })}</td>
            <td>
              <span className={styles.positive}>
                {I18n.formatCurrency(
                  Helper.formatPrice(
                    statement.total_excl_vat,
                    statement.invoice_ccy
                  )
                )}
              </span>
            </td>
            <td>
              <span className={styles.positive}>
                {I18n.formatCurrency(
                  Helper.formatPrice(
                    statement.vat_amount,
                    statement.invoice_ccy
                  )
                )}
              </span>
            </td>
            <td>
              <span className={styles.positive}>
                {I18n.formatCurrency(
                  Helper.formatPrice(
                    statement.total_incl_vat,
                    statement.invoice_ccy
                  )
                )}
              </span>
            </td>
            <td>
              <span className={styles.btnWrapper}>
                {/* First Tooltip */}
                <Button
                  className={styles.btnCtr}
                  variant="transparent"
                  data-tip
                  data-for={"tooltip1"}
                  onClick={() => props.exportInvoice(statement.invoice_no)}
                >
                  <Icon name="download" className={styles.printIcon} />
                </Button>
                <Tooltip
                  className={styles.tooltip}
                  place="left"
                  type="dark"
                  effect="solid"
                  id={"tooltip1"}
                >
                  <span>
                    {I18n.getText("statement.tooltip-export", {}, "Export")}
                  </span>
                </Tooltip>

                {/* Second tooltip */}
                <a
                  href={statement.url}
                  target="_blank"
                  data-tip
                  data-for={"tooltip2"}
                >
                  <Button className={styles.btnCtr} variant="transparent">
                    <Icon name="print" className={styles.printIcon} />
                  </Button>
                </a>
                <Tooltip
                  className={styles.tooltip}
                  place="left"
                  type="dark"
                  effect="solid"
                  id={"tooltip2"}
                >
                  <span>
                    {I18n.getText("statement.tooltip-print", {}, "Print")}
                  </span>
                </Tooltip>
              </span>
            </td>
          </tr>
        );
      })
    : "";

  const invoiceListMobile = (
    <div>
      <InvoiceListMobile
        data={props.data}
        currencyCode={props.currencyCode}
        exportInvoice={props.exportInvoice}
        browser={props.browser}
      />
    </div>
  );

  return (
    <div className={styles.ctr}>
      {props.browser && props.browser.greaterThan.tablet ? (
        <table className={styles.table}>
          <tr className={`${styles.row} ${styles.head}`}>
            <th>
              {I18n.getText("statement.invoice-no", {}, "Invoice number")}
            </th>
            <th>{I18n.getText("statement.date", {}, "Date")}</th>
            <th>{I18n.getText("statement.total-item", {}, "Total Items")}</th>
            <th>{I18n.getText("statement.currency", {}, "Currency")}</th>
            <th>{I18n.getText("statement.total-ex-vat", {}, "Total")}</th>
            <th>{I18n.getText("statement.vat-invoice", {}, "VAT Amount")}</th>
            <th>{I18n.getText("statement.amount-invoice", {}, "Amount")}</th>
            <th />
          </tr>
          {statementList}
        </table>
      ) : (
        invoiceListMobile
      )}
    </div>
  );
};

export default StatementList;



// WEBPACK FOOTER //
// ./src/components/statement/InvoiceList.js